export default __webpack_public_path__ + "static/media/Smart_plug_Avg_W.4d973fcd.svg";